// @ts-nocheck
import React from 'react'
import { Hidden, Theme } from '@mui/material'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import { Navbar } from '../../components/Navbar/Navbar'
import { IGame } from '../../api/types/game'
import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { gameQueryKey } from '../../api/queries'
import { queryGame } from '../../api/queries'
import { ErrorHandler } from '../../components/ErrorHandler/ErrorHandler'
import { fromAxiosError } from '../../context/GlobalError'
import { Chat } from './components/Chat/Chat'
import cx from 'classnames'
import { Tab, Tabs } from '@tarragon/swipeable-tabs/dist'
import { SplitView } from '../../components/SplitView/SplitView'
import { CharacterTab } from './components/Character/CharacterTab'
import { Tools } from './components/Tools/Tools'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      height: '100%',
      flexFlow: 'column',
    },
    header: {
      flex: '0 1 auto',
    },
    content: {
      flex: '1 1 auto',
      overflow: 'auto',
      padding: '0px',
    },
    windows: {
      display: 'flex',
      height: '100%',
      flexFlow: 'row',
      flex: '1 1 auto',
      overflow: 'auto',
      padding: '0px',
    },
    playPanel: {
      // width: '50%',
    },
  })
)

interface IParams {
  game_slug: string
}

export const Game = () => {
  const { game_slug } = useParams<keyof IParams>()
  const {
    isLoading: gameLoading,
    data: game,
    error,
  } = useQuery<IGame>(gameQueryKey(game_slug || ''), () => queryGame(game_slug || ''))
  const classes = useStyles()

  const [selectedTab, setSelectedTab] = React.useState('Chat')
  const changeTab: (selectedTab: { label: string; key: string | number }) => void = updatedTab => {
    setSelectedTab(updatedTab.label)
  }

  return (
    <>
      <div className={classes.container}>
        <div className={classes.header}>
          <Navbar />
        </div>
        <ErrorHandler loading={gameLoading} error={fromAxiosError(error)}>
          {game && (
            <div className={cx(classes.content, classes.container)}>
              <Hidden mdDown>
                <SplitView
                  localStorageName={'charPanelSize'}
                  className={cx(classes.windows)}
                  left={<Chat game={game} />}
                  right={<Tools game={game} />}
                />
              </Hidden>

              <Hidden mdUp>
                <Tabs value={selectedTab} onChange={changeTab} tabBarCSS={'display: none'}>
                  <Tab label="Character" key={0}>
                    <CharacterTab
                      showChatTab={() => changeTab({ label: 'Chat', key: 1 })}
                      game={game}
                    />
                  </Tab>
                  <Tab label="Chat" key={1}>
                    <div className={cx(classes.windows)}>
                      <Chat game={game} />
                    </div>
                  </Tab>
                </Tabs>
              </Hidden>
            </div>
          )}
        </ErrorHandler>
      </div>
    </>
  )
}
